module.exports = __webpack_public_path__ + "static/media/18ECA27.0f4453fb.jpg";